<template>
  <header class="c-site-header" :class="{ 'c-site-header--is-active': flyoutIsOpen }">
    <router-link :to="{ name: 'home' }" @click.native="closeFlyout()">
      <img class="c-site-header__logo" src="@/assets/logo.svg" alt="Chatham Island Taiko Trust">
    </router-link>
    <div class="c-site-header__donate-btn">
      <router-link class="c-btn c-btn--tertiary" :to="{ name: 'donate' }" @click.native="closeFlyout()">Donate now</router-link>
    </div>
    <button class="c-hamburger" @click="toggleFlyout" :class="{ 'c-hamburger--is-active': flyoutIsOpen }">
      <span class="c-hamburger__line"></span>
      <span class="c-hamburger__line"></span>
      <span class="c-hamburger__line"></span>
    </button>
    <div class="c-flyout" :class="{ 'c-flyout--is-open': flyoutIsOpen }">
      <div class="c-flyout__main">
        <ul class="c-flyout__list">
          <li class="c-flyout__item js-flyout-item">
            <router-link class="c-flyout__link" :to="{ name: 'about' }" @click.native="closeFlyout()">
              <span>About us</span>
            </router-link>
          </li>
          <li class="c-flyout__item js-flyout-item">
            <router-link class="c-flyout__link" :to="{ name: 'projects' }" @click.native="closeFlyout()">
              <span>Projects</span>
            </router-link>
            <ul class="c-flyout__list c-flyout__list--nested" v-if="activeProjects">
              <li class="c-flyout__item js-flyout-item" v-for="project in activeProjects" :key="project.id">
                <router-link class="c-flyout__link js-flyout__link" :to="{ name: 'project', params: { slug: project.slug }}" @click.native="closeFlyout()">
                  <span>{{ project.title }}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="c-flyout__item js-flyout-item">
            <router-link class="c-flyout__link" :to="{ name: 'birds' }" @click.native="closeFlyout()">
              <span>Sponsored Birds</span>
            </router-link>
          </li>
          <li class="c-flyout__item js-flyout-item">
            <router-link class="c-flyout__link" :to="{ name: 'donate' }" @click.native="closeFlyout()">
              <span>Donate</span>
            </router-link>
          </li>
          <li class="c-flyout__item js-flyout-item">
            <router-link class="c-flyout__link" :to="{ name: 'news' }" @click.native="closeFlyout()">
              <span>News</span>
            </router-link>
          </li>
          <li class="c-flyout__item js-flyout-item">
            <router-link class="c-flyout__link" :to="{ name: 'contact' }" @click.native="closeFlyout()">
              <span>Contact</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SiteHeader',
  data () {
    return {
      flyoutIsOpen: false,
      flyoutDuration: 500,
      flyoutItemDuration: 100,
      activeProjects: null
    }
  },
  mounted () {
    this.getActiveProjects()
  },
  methods: {
    getActiveProjects () {
      axios
        .get('/api/activeProjects.json')
        .then(response => {
          this.activeProjects = response.data.data
        })
    },
    toggleFlyout () {
      if (this.flyoutIsOpen) this.closeFlyout()
      else this.openFlyout()
    },
    openFlyout () {
      this.flyoutIsOpen = !this.flyoutIsOpen
      let vm = this
      window.scrollTo(0, 0)
      const flyoutItemsObj = document.querySelectorAll('.js-flyout-item')
      const flyoutItems = Object.values(flyoutItemsObj)
      document.documentElement.classList.add('u-no-scroll')
      document.body.classList.add('u-no-scroll')
      document.getElementById('app').classList.add('u-no-scroll')
      document.getElementById('app-inner').classList.add('u-no-scroll')
      setTimeout(function () {
        flyoutItems.map((v, i) => {
          const item = v
          setTimeout(function () {
            item.classList.add('js-slide-in')
          }, vm.flyoutItemDuration * i)
        })
      }, vm.flyoutDuration)
    },
    closeFlyout () {
      if (this.flyoutIsOpen) {
        this.flyoutIsOpen = !this.flyoutIsOpen
        const flyoutItemsObj = document.querySelectorAll('.js-flyout-item')
        for (let i = 0; i < flyoutItemsObj.length; i++) {
          flyoutItemsObj[i].classList.remove('js-slide-in')
        }
        document.documentElement.classList.remove('u-no-scroll')
        document.body.classList.remove('u-no-scroll')
        document.getElementById('app').classList.remove('u-no-scroll')
        document.getElementById('app-inner').classList.remove('u-no-scroll')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SiteHeader.vue